module.exports = __webpack_public_path__ + "img/empty_role.3522b4d6.svg";